/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".loader[_ngcontent-%COMP%]{position:relative;min-height:100px}.loader[_ngcontent-%COMP%]   mat-spinner[_ngcontent-%COMP%]{height:40px;width:40px;position:absolute;left:calc(50% - 20px);top:calc(50% - 20px)}.loader[_ngcontent-%COMP%]   mat-spinner[_ngcontent-%COMP%]     path{stroke:#29b6f6}"];
export { styles as styles };
